<H4>[GENERAR ARCHIVO]</H4>
<ul>
    <li><a routerLink="/FilesGenerationCSV">[GENERAR ARCHIVO CSV]</a></li>    
    <li><a routerLink="/FilesGenerationXLS">[GENERAR ARCHIVO XLS]</a></li>
    <li><a routerLink="/FilesGenerationPDF">[GENERAR ARCHIVO PDF]</a></li>
    <li><a routerLink="/FilesGenerationZIP">[GENERAR ARCHIVO ZIP]</a></li>
</ul>
<hr>
<a routerLink="/Home">Volver al Menú</a>